<div class="mt-3 ml-2 d-flex justify-content-between align-items-start">
  <div>
    <mat-icon
      class="back-btn cursor-pointer outline-none mr-3"
      routerLink="../"
      svgIcon="app_arrow_left"
    ></mat-icon>
    <span class="archive-title">Archived {{ pageData.headerText }}</span>
  </div>
  <button
    mat-button
    (click)="makeActive.emit(selection.selected)"
    [disabled]="selection.isEmpty()"
    class="button-primary mat-button-base mb-4 px-2 d-flex justify-content-center align-items-center"
  >
    <span class="px-3">Make Active</span>
  </button>
</div>
@if (notEmpty) {
  <div
    class="d-flex justify-content-center align-items-center empty-content-box"
  >
    {{ pageData.noData }}
  </div>
} @else {
  @if (showData) {
    <div class="white-box d-flex flex-column mb-3 archive-box">
      <div class="element-list">
        <table mat-table [dataSource]="dataSource" class="px-3 w-100">
          @for (key of tableStructure; track key) {
            <ng-container [matColumnDef]="key.title">
              <th mat-header-cell *matHeaderCellDef [ngClass]="key.class">
                {{ key.title !== "select" ? key.title : "" }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                [ngClass]="key.class"
                [title]="element[key.key]"
              >
                @switch (key.title) {
                  @case ("select") {
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      color="primary"
                      disableRipple="true"
                      (change)="$event ? selection.toggle(element) : null"
                      [checked]="selection.isSelected(element)"
                    >
                    </mat-checkbox>
                  }
                  @case ("img") {
                    <div
                      class="circle-image-box mr-2 d-flex justify-content-center align-items-center"
                    >
                      {{ element[pageData.nameKey].charAt(0).toUpperCase() }}
                    </div>
                  }
                  @case ("Full Name" || "Location Name") {
                    <div class="text-truncate user-name">
                      {{ element[key.key] }}
                    </div>
                  }
                  @default {
                    <span>
                      {{ element[key.key] }}
                    </span>
                  }
                }
              </td>
            </ng-container>
          }
          <tr
            mat-header-row
            *matHeaderRowDef="displayedOptions.displayedColumns; sticky: true"
            class="align-middle"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedOptions?.displayedColumns"
            (click)="selection.toggle(row)"
            class="small-box cursor-pointer line mt-5"
          ></tr>
        </table>
      </div>
    </div>
  }
}
